import React, { useState, useEffect, createRef } from 'react';
import { Form, Input, Select, Button, BackTop } from 'antd';
import { useTranslation } from 'react-i18next';
import useNotify from '../../../../context/Notification/useNotify';
import IconEmailTemplate from '../../../../assets/Images/icons/icon-email-template';
import IconEmailTemplateRight from '../../../../assets/Images/icons/icon-email-template-right';
import IconWhiteFactLogo from '../../../../assets/Images/icons/icon-email-template-logo';
import IconEmailTemplatActive from '../../../../assets/Images/icons/icon-email-template-active';
import IconFlowDone from '../../../../assets/Images/icons/icon-flow-done';
import {
    PlusCircleOutlined,
    PaperClipOutlined,
    DeleteOutlined,
} from '@ant-design/icons';
import GlobalService from '../../../../services/Global.service';
import ModalDelete from '../../../../components/Shared/modal/delete';
import moment from 'moment';
import parse from 'html-react-parser';

// Flow Complete - Last
export default function TemplateEmail3({
    form,
    contact,
    setImageFile,
    setDocFile,
    imageFile,
    docFile,
    dsFormData,
    detail,
    emailList,
    operationList,
    logoCompany,
}) {
    const { t, i18n } = useTranslation();
    let lang = i18n.language;
    const ref = createRef();
    const notify = useNotify();

    const { TextArea } = Input;

    const [operations, setOperations] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [proofOfIdentityList, setProofOfIdentityList] = useState([]);
    const filteredOptions = emailList.filter((o) => !selectedItems.includes(o));

    const [deleteLoding, setDeleteLoding] = useState(false);
    const [openDelete, setOpenDelete] = useState({
        open: false,
        file: null,
    });

    useEffect(() => {
        setSelectedItems(emailList);
        setOperations(operationList?.operationDepartment);
        form.setFieldsValue({
            assignTo: emailList,
            dataSubjectRemark:
                'คำขอใช้สิทธิรายการนี้ได้รับการดำเนินการเสร็จสิ้นแล้ว \nกรณีร้องขอเอกสาร ท่านสามารถเปิดดูรายละเอียดได้',
        });
        if (dsFormData) {
            const proofOfIdentity =
                dsFormData?.evidenceInformation?.proofOfIdentity?.filter(
                    (e) => e?.id !== '0ecb41743d7111edb8780242ac120002'
                );
            setProofOfIdentityList(proofOfIdentity);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [emailList, operationList, dsFormData]);

    const [fileTask, setFileTask] = useState([]);

    const _getTagOperationStatus = (e) => {
        switch (e) {
            case 'Doing':
                return {
                    color: '#F9C153',
                };
            case 'Task Done':
                return {
                    color: '#4ACE8F',
                };
            case 'Task Canceled':
                return {
                    color: '#F0536F',
                };
            case 'Task Canceling':
                return {
                    color: '#65707A',
                };
            case 'To Do':
                return {
                    color: '#1890FF',
                };
            default:
                return { color: '#FFF' };
        }
    };

    // File Type
    const allowedType = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', //docx
        'image/png',
        'image/jpeg',
        'image/jpg',
        'application/zip',
        'application/x-rar',
        'application/x-zip-compressed',
        'application/pdf',
        // 'application/msword', // .doc
        'application/pdf', // .pdf
        'application/vnd.ms-excel', // .xls
    ];

    const onChange = async (e) => {
        let size = 0;
        for (let i = 0; i < e.target.files.length; i++) {
            const fileType = e.target.files[i].type;
            size += e.target.files[i].size;
            // console.log(fileType)
            if (!allowedType.includes(fileType)) {
                // console.log(fileType)
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description:
                        'Allowed file type: .jpg, jpeg, .png, .docx, .xlsx, .pdf, .zip, .rar',
                });
                return;
            }
        }
        const fileSize = size / 1024 / 1024;
        if (fileSize <= 5120) {
            const allowedTypeDoc = [
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
                'application/msword', // .doc
                'application/pdf', // .pdf
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                'application/vnd.ms-excel', // .xls
                'application/zip',
                'application/x-rar',
                'application/x-zip-compressed',
            ];
            const allowedTypeImage = [
                'image/png', // .png
                'image/jpeg', // .jepg
                'image/jpg', // .jepg
            ];
            let bodyFormDocData = new FormData();
            let imageList = [];
            let image = [];
            for (let i = 0; i < e.target.files.length; i++) {
                let ImageData = new FormData();
                const file = e.target.files[i];
                const fileType = file.type;
                ImageData.append('image', file);
                ImageData.append('fileName', file.name);
                ImageData.append('action', 'image-create-application');
                if (allowedTypeImage.includes(fileType)) {
                    try {
                        const { data } = await GlobalService.uploadImage(
                            ImageData
                        );
                        if (data?.resultData?.imageId) {
                            const item = {
                                fileStorageId: data.resultData?.imageId,
                                fileName: data.resultData?.imageName,
                                fileType: data.resultData?.imageType,
                            };
                            image.push(data?.resultData);
                            imageList.push(item);
                        }
                    } catch (error) {
                        console.log(error);
                    }
                } else if (allowedTypeDoc.includes(fileType)) {
                    const formfile = e.target.files[i];
                    const utf8Name = encodeURIComponent(formfile.name);
                    const header = `form-data; name="uploadFile"; filename*=UTF-8''${utf8Name}`;
                    bodyFormDocData.append('doc', formfile, header);
                }
            }
            setImageFile([...imageFile, ...image]);
            const docLength = Array.from(bodyFormDocData.keys()).length;

            if (docLength > 0) {
                bodyFormDocData.append('action', 'ds-request-step-4');
                try {
                    const { data } = await GlobalService.uploadDoc(
                        bodyFormDocData
                    );
                    if (data?.resultData) {
                        // setFileList([...fileTask, ...data?.resultData]);
                        setDocFile([...docFile, ...data?.resultData]);
                        imageList = imageList.concat(...data?.resultData);
                    }
                } catch (error) {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to uploaded'),
                    });
                    console.log(error);
                }
            }
            setFileTask([...fileTask, ...imageList]);
            // setValueInput(e.target.value);
        } else {
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Upload error file size is wrong'),
            });
            return;
        }
    };

    const onInputClick = (event) => {
        event.target.value = '';
    };

    // const checkFile = () => {
    //     if (files && files.length > 0) {
    //         // console.log('false');
    //         setValidateFile(false);
    //         return Promise.resolve();
    //     }
    //     // console.log('true');
    //     setValidateFile(true);
    //     return Promise.reject(new Error('This field is required.'));
    // };

    const deleteFile = async (file) => {
        const imageType = [
            'png', // .png
            'jpeg', // .jepg
            'jpg', // .jepg
        ];
        const id = file?.fileStorageId;
        if (imageType.includes(file?.fileType)) {
            await GlobalService.deleteImage(id)
                .then((res) => {
                    setDeleteLoding(false);
                    if (res.data.resultCode === 1) {
                        setOpenDelete({
                            open: false,
                            file: null,
                        });
                        // console.log(
                        //     imageFile.filter((file) => file.imageId !== id)
                        // );
                        setImageFile(
                            imageFile.filter((file) => file.imageId !== id)
                        );
                        setFileTask(
                            fileTask.filter((file) => file.fileStorageId !== id)
                        );
                    }
                })
                .catch((error) => {
                    console.log(error);
                    setDeleteLoding(false);
                    setOpenDelete({
                        open: false,
                        file: null,
                    });
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to deleted'),
                    });
                });
        } else {
            await GlobalService.deleteFile(id)
                .then((res) => {
                    setDeleteLoding(false);
                    if (res.data.resultCode === 1) {
                        setOpenDelete({
                            open: false,
                            file: null,
                        });
                        setDocFile(
                            docFile.filter((file) => file.fileStorageId !== id)
                        );
                        setFileTask(
                            fileTask.filter((file) => file.fileStorageId !== id)
                        );
                    }
                })
                .catch((error) => {
                    setDeleteLoding(false);
                    console.log(error);
                    setOpenDelete({
                        open: false,
                        file: null,
                    });
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to deleted'),
                    });
                });
        }
    };

    const downloadFile = async (file) => {
        const imageType = [
            'png', // .png
            'jpeg', // .jepg
            'jpg', // .jepg
        ];
        if (imageType.includes(file?.fileType)) {
            await GlobalService.getImage(file?.fileStorageId).then((res) => {
                const itemImg = `data:image/${file?.fileType};base64,${res?.data?.resultData?.imageId}`;
                // `data:image/png;base64,${data.resultData?.imageId}`
                if (res.data) {
                    const objectURL = itemImg;
                    const link = document.createElement('a');
                    link.href = objectURL;
                    link.download = file?.fileName + '.' + file.fileType;
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                }
            });
        } else {
            await GlobalService.downloadDoc(file?.fileStorageId).then((res) => {
                if (res.data) {
                    const objectURL = URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = objectURL;
                    link.download = file?.fileName + '.' + file.fileType;
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                }
            });
        }
    };

    return (
        <>
            {/* {template1} */}
            {/* {template1} */}
            {/* {template1} */}
            {/* {template1} */}
            {/* {template1} */}
            {/* {template1} */}
            {/* {template1} */}

            <div className="col-span-1 bg-white h-max rounded-t-lg">
                <div
                    className="px-8 py-4 text-[#7B67FB] text-[16px] font-semibold"
                    style={{ borderBottom: '1px solid #ECECEC' }}
                >
                    อีเมลส่งถึงเจ้าของข้อมูล
                </div>
                <div className="grid grid-cols-12 gap-2">
                    <div className="col-span-12 px-8">
                        <div className="text-[14px] text-[#65707A] my-2">
                            to :{' '}
                            <span className="text-[#1890FF]">
                                {dsFormData?.dataSubjectInformation?.email ||
                                    '-'}
                            </span>
                        </div>
                        <div className="flex justify-between">
                            <div className="text-[14px] text-[#65707A]">
                                cc :{' '}
                                <span className="text-[#1890FF]">
                                    {dsFormData?.applicantInformation?.email ||
                                        '-'}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="px-44 py-14 text-[16px] bg-[#ECECEC] rounded-b-lg mb-4">
                <div className="text-center my-4" hidden={!logoCompany}>
                    <img
                        src={logoCompany}
                        className="object-cover w-auto h-20"
                        alt="logo"
                    />
                </div>
                <div className="p-8 text-[16px] bg-white rounded-lg">
                    <div className="text-[14px] font-semibold">
                        เราได้ดำเนินการตามคำขอใช้สิทธิของคุณเรียบร้อยแล้ว
                    </div>
                    <div className="flex justify-center">
                        <IconFlowDone />
                    </div>

                    <p className="text-[14px] font-semibold">
                        อัปเดตล่าสุดเมื่อ :{' '}
                        <span className="font-normal">
                            {moment(new Date()).format('DD/MM/YYYY') || '-'}
                        </span>
                    </p>
                    <div className="text-[14px] font-semibold">
                        ข้อมูลเพิ่มเติม{' '}
                    </div>
                    <Form.Item className="mt-2" name={'dataSubjectRemark'}>
                        <TextArea
                            size="large"
                            className="bg-[#F4F6FC] text-[14px]"
                            autoSize={{ minRows: 3, maxRows: 4 }}
                            placeholder={t('MyTask.DescribeDetails')}
                        />
                    </Form.Item>

                    <div className="text-[14px] font-semibold mt-4 mb-1">
                        ไฟล์แนบเพิ่มเติม{' '}
                    </div>
                    <Form.Item
                        // label="Import File Activity"
                        extra={
                            <>
                                <div>*One-time upload is a max of 5GB. </div>
                                <div>
                                    (Allowed file types: .jpg, jpeg, .png,
                                    .docx, .xlsx, .pdf, .zip, .rar)
                                </div>
                            </>
                        }
                        name="file"
                    >
                        <>
                            <div className="border-solid border border-blue-400 rounded-md min-h-[112px] px-2">
                                <label
                                    onClick={() => ref.current.click()}
                                    className={'cursor-pointer'}
                                >
                                    <Button
                                        className="mt-2 border-dashed border border-sky-300 text-sky-500 bg-sky-50 mb-2"
                                        icon={<PlusCircleOutlined />}
                                    >
                                        {t('choose file')}
                                    </Button>
                                    <input
                                        ref={ref}
                                        disabled={fileTask?.length === 10}
                                        onChange={onChange}
                                        onClick={onInputClick}
                                        type="file"
                                        style={{ display: 'none' }}
                                        multiple
                                        accept={allowedType.join(',')}
                                        // value={valueInput}
                                    />
                                </label>
                                <div className="pb-2">
                                    {fileTask?.map((file, i) => {
                                        return (
                                            <div className="flex justify-between">
                                                <div
                                                    key={file.fileStorageId}
                                                    className="text-new space-x-2 cursor-pointer"
                                                    onClick={() =>
                                                        downloadFile(file)
                                                    }
                                                >
                                                    <PaperClipOutlined />
                                                    <span className="font-semibold ">
                                                        {file.fileName}.
                                                        {file.fileType}
                                                    </span>
                                                </div>
                                                <div
                                                    onClick={() => {
                                                        // console.log(file);
                                                        setOpenDelete({
                                                            open: true,
                                                            file: file,
                                                        });
                                                    }}
                                                    className="text-[#95A0A8] cursor-pointer"
                                                >
                                                    <DeleteOutlined />
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </>
                    </Form.Item>
                    <div className="text-[14px] font-semibold text-[#65707A] mt-8">
                        หากมีข้อสงสัยประการใด
                        สามารถติดต่อคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล
                    </div>
                    <div className="text-[14px] text-[#65707A] whitespace-pre-line">
                        {lang === 'en'
                            ? parse(contact?.staffNameDPOEn || '-')
                            : parse(contact?.staffNameDPOTh || '-')}
                    </div>

                    <div
                        className="my-4"
                        style={{ borderBottom: ' 2px solid #F5F6FF' }}
                    ></div>
                    <div className="p-4 text-center text-[12px]">
                        Copyright © 2022 Whitefact
                    </div>
                </div>
            </div>
            {/* {template2} */}
            {/* {template2} */}
            {/* {template2} */}
            {/* {template2} */}
            {/* {template2} */}
            {/* {template2} */}
            {/* {template2} */}
            <div className="col-span-1 bg-white h-max rounded-t-lg">
                <div
                    className="px-8 py-4 text-[#7B67FB] text-[16px] font-semibold"
                    style={{ borderBottom: '1px solid #ECECEC' }}
                >
                    อีเมลส่งถึงผู้ที่มอบหมายงาน
                </div>
                <div className="grid grid-cols-12 gap-2">
                    <div className="col-span-12 px-8">
                        <Form.Item
                            name={'assignTo'}
                            className="mt-2 mb-2"
                            label={
                                <span className="text-[14px] text-[#65707A] text-left">
                                    {t('to')}
                                </span>
                            }
                            rules={[
                                {
                                    required: true,
                                    message: 'This field is required.',
                                },
                            ]}
                        >
                            <Select
                                mode="multiple"
                                placeholder="Please Select"
                                value={selectedItems}
                                onChange={setSelectedItems}
                                style={{
                                    width: '77%',
                                }}
                            >
                                {filteredOptions.map((item) => (
                                    <Select.Option key={item} value={item}>
                                        {item}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <div className="flex justify-between">
                            <div className="text-[14px] text-[#65707A]">
                                cc : -
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="px-44 py-14 text-[16px] bg-[#ECECEC] rounded-b-lg mb-4">
                <div className="text-center my-2">
                    <IconWhiteFactLogo />
                </div>

                <div className="p-8 text-[16px] bg-white rounded-lg">
                    <div className="text-[14px] font-semibold">
                        คำขอใช้สิทธิหมายเลข
                        <span className="text-[#1890FF]">
                            {' '}
                            {detail?.requestId || '-'}{' '}
                        </span>
                        ได้รับการดำเนินการเสร็จสิ้นแล้ว
                    </div>

                    <div className="text-[14px] font-semibold my-4">
                        ดำเนินการโดยแผนก
                    </div>
                    {operations?.map((e) => (
                        <>
                            <div className="py-1 px-4 bg-[#F5F6FF] my-1 rounded">
                                <div className="grid grid-cols-10 gap-2 p-1">
                                    <div className="flex items-center col-span-2">
                                        <div
                                            className="rounded-xl -my-1 text-center w-full text-[12px] bg-white"
                                            style={{
                                                color: _getTagOperationStatus(
                                                    e?.taskStatusName
                                                ).color,
                                                borderColor:
                                                    _getTagOperationStatus(
                                                        e?.taskStatusName
                                                    ).color,
                                                border: '1px solid',
                                            }}
                                        >
                                            {e?.taskStatusName}
                                        </div>
                                    </div>
                                    <div className="flex items-center col-span-2">
                                        <div className="text-[12px] font-semibold">
                                            {e?.departmentName || '-'}
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-end col-span-6">
                                        <div className="flex items-center justify-end text-[12px] font-semibold space-x-2">
                                            <span>Operation Person : </span>
                                            <span className="font-normal">
                                                {e?.operationPerson ||
                                                    'Waiting for a response'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ))}
                    <div className="text-[14px] font-semibold my-4">
                        รายละเอียดคำขอใช้สิทธิ
                    </div>

                    <div className="text-[14px] font-semibold">
                        หมายเลขติดตามคำขอใช้สิทธินี้ :{' '}
                        <span className="font-normal text-[#464E5F]">
                            {detail?.requestId || '-'}
                        </span>
                    </div>
                    <div className="text-[14px] font-semibold">
                        เปิดคำขอใช้สิทธิเมื่อวันที่ :{' '}
                        <span className="font-normal text-[#464E5F]">
                            {detail?.requestDate
                                ? moment(detail?.requestDate).format(
                                      'DD/MM/YYYY'
                                  )
                                : '-'}{' '}
                        </span>
                    </div>
                    <div className="text-[14px] font-semibold">
                        ชื่อเจ้าของข้อมูล :{' '}
                        <span className="font-normal text-[#464E5F]">
                            {dsFormData?.dataSubjectInformation?.firstName
                                ? `${dsFormData?.dataSubjectInformation?.firstName} ${dsFormData?.dataSubjectInformation?.lastName}`
                                : '-'}
                        </span>
                    </div>
                    <div className="text-[14px] font-semibold">
                        ตัวแทนในการยื่นคำร้อง :{' '}
                        <span className="font-normal text-[#464E5F]">
                            {dsFormData?.applicantInformation?.firstName
                                ? `${dsFormData?.applicantInformation?.firstName} ${dsFormData?.applicantInformation?.lastName}`
                                : '-'}
                        </span>
                    </div>
                    <div className="text-[14px] font-semibold">
                        ประเภทเจ้าของข้อมูล :{' '}
                        <span className="font-normal text-[#464E5F]">
                            {lang === 'en'
                                ? dsFormData?.dataSubjectInformation
                                      ?.dataSubjectNameEn || '-'
                                : dsFormData?.dataSubjectInformation
                                      ?.dataSubjectNameTh || '-'}
                        </span>
                    </div>
                    <div className="text-[14px] font-semibold">
                        ประเภทการขอใช้สิทธิ :{' '}
                        <span className="font-normal text-[#464E5F]">
                            {lang === 'en'
                                ? dsFormData?.detailsOfClaim
                                      ?.requestTypeShortName || '-'
                                : dsFormData?.detailsOfClaim
                                      ?.requestTypeShortName || '-'}
                        </span>
                    </div>

                    <div className="text-[14px] font-semibold mt-4 mb-1">
                        ข้อมูลส่วนบุคคลที่ประสงค์จะใช้สิทธิ
                    </div>
                    <div className="text-[14px] font-normal text-[#464E5F] whitespace-pre-line">
                        {dsFormData?.detailsOfClaim?.purpose || '-'}
                    </div>

                    <div className="text-[14px] font-semibold mt-4 mb-1">
                        รายละเอียดการขอใช้สิทธิและเหตุผลในการขอ
                    </div>
                    <div className="text-[14px] font-normal text-[#464E5F] whitespace-pre-line">
                        {dsFormData?.detailsOfClaim?.reason || '-'}
                    </div>

                    <div className="text-[14px] font-semibold mt-4 mb-1">
                        หลักฐานประกอบคำขอใช้สิทธิ
                    </div>
                    <div className="text-[14px] font-normal text-[#464E5F]">
                        {dsFormData?.evidenceInformation?.evidence
                            ? 'มีการแนบ'
                            : 'ไม่มีการแนบ'}
                    </div>

                    <div className="text-[14px] font-semibold mt-4 mb-1">
                        หลักฐานยืนยันตัวตน
                    </div>
                    {proofOfIdentityList?.length > 0 ? (
                        <>
                            {proofOfIdentityList?.map((e) => (
                                <>
                                    <div className="text-[14px] font-normal text-[#464E5F] ml-2">
                                        &#8226; {e?.name}
                                    </div>
                                </>
                            ))}
                        </>
                    ) : (
                        <></>
                    )}
                    {dsFormData?.evidenceInformation?.proofOfIdentityAddon ? (
                        <div className="text-[14px] font-normal text-[#464E5F] ml-2">
                            &#8226;{' '}
                            {
                                dsFormData?.evidenceInformation
                                    ?.proofOfIdentityAddon
                            }
                        </div>
                    ) : (
                        <></>
                    )}

                    <div className="text-[14px] font-semibold mt-4 mb-1">
                        ข้อมูลเพิ่มเติม
                    </div>
                    <Form.Item className="mt-2" name={'operatorRemark'}>
                        <TextArea
                            size="large"
                            className="bg-[#F4F6FC] text-[14px]"
                            autoSize={{ minRows: 3, maxRows: 4 }}
                            placeholder={t('ระบุข้อความ')}
                        />
                    </Form.Item>

                    <div className="text-[14px] font-semibold my-4">
                        ดูรายละเอียดเพิ่มเติมและเริ่มทำงานได้ที่เมนู Data
                        Subject 360 {'>'}{' '}
                        <span className="text-[#7B67FB]">My Task</span>
                    </div>

                    <div
                        className="my-4"
                        style={{ borderBottom: ' 2px solid #F5F6FF' }}
                    ></div>
                    <div className="p-4 text-center text-[12px] text-[#171717]">
                        Copyright © 2022 Whitefact
                    </div>
                </div>
            </div>
            <BackTop>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>

            <ModalDelete
                loading={deleteLoding}
                open={openDelete?.open}
                handelClose={() => {
                    setOpenDelete({
                        open: false,
                        file: null,
                    });
                }}
                handelOk={() => {
                    setDeleteLoding(true);
                    const file = openDelete.file;
                    deleteFile(file);
                }}
            />
        </>
    );
}

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
